import PregnancyWeekSelect from './pregnancy-week-select'

export default PregnancyWeekSelect
